// lib
import { dissoc, map, pipe } from "ramda";

// dissoc multiple keys from object
export const mdissoc = (keys, object) => pipe(...map(dissoc, keys))(object);
